export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  contentHtml: string;
  categorySlug: string;
  categoryName: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: number;
  image: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'art-001',
    slug: 'best-edc-gear-2024',
    title: '2024年度EDC装备终极指南：从口袋到背包的硬核选择',
    excerpt: '每天随身携带的装备，决定了一个男人的准备程度。这篇万字长文深度评测了20款EDC必备单品，帮你打造一套真正实用的日常携带系统。',
    contentHtml: `<p>EDC（Every Day Carry）不只是一个潮流词汇，它代表着一个男人对日常生活的态度——随时准备好应对各种状况。</p>
<p>一套好的EDC系统，应该覆盖以下几个维度：切割工具、照明工具、书写工具、多功能工具、急救用品以及收纳系统。每个维度我们精选了2-3款经过长期实测的单品，从性价比到顶级工艺，总有一款适合你。</p>
<h2>切割工具：口袋中的力量</h2>
<p>一把好刀是EDC的核心。我们测试了来自美国、日本、德国的多款折叠刀，从刃材、锁定机制、人体工学到日常实用性，全面对比。最终推荐的三款分别覆盖了入门、进阶和收藏级别。</p>
<p>钢材的选择至关重要——CPM S30V、VG-10、M390各有优劣，我们将详细解析每种钢材的特性与适用场景。</p>
<h2>照明工具：黑暗中可靠的伙伴</h2>
<p>小巧而强大的EDC手电是现代男人的标配。从钥匙扣级别的微型灯到可放入口袋的中型灯，流明数、续航、防水等级都是考量的关键指标。</p>
<h2>收纳系统：让一切井井有条</h2>
<p>再好的装备，如果杂乱无章地塞在口袋里，关键时刻也无法快速取用。EDC托盘、收纳包、腰带系统——我们帮你找到最适合的整理方案。</p>`,
    categorySlug: 'hardcore-gear',
    categoryName: '硬核装备',
    author: '老炮',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20mature%20Chinese%20man%20in%20his%2040s%20with%20short%20hair%20and%20beard%2C%20wearing%20dark%20flannel%20shirt%2C%20confident%20expression%2C%20warm%20studio%20lighting%2C%20dark%20background&width=100&height=100&seq=avatar-laopao&orientation=squarish',
    publishDate: '2024-12-15',
    readTime: 12,
    image: 'https://readdy.ai/api/search-image?query=Top%20down%20photography%20of%20carefully%20arranged%20everyday%20carry%20items%20on%20dark%20leather%20mat%2C%20including%20titanium%20folding%20knife%20copper%20flashlight%20leather%20wallet%20metal%20pen%20and%20paracord%20keychain%2C%20warm%20overhead%20lighting%20creating%20defined%20shadows%2C%20minimalist%20product%20flatlay%20photography%2C%20masculine%20dark%20aesthetic&width=1200&height=675&seq=article-edc-001&orientation=landscape',
    tags: ['EDC', '刀具', '手电', '收纳', '每日携带'],
    featured: true,
  },
  {
    id: 'art-002',
    slug: 'selvedge-denim-guide',
    title: '养牛入门：从原牛到落色的完整养牛指南',
    excerpt: '一条好的原色牛仔裤，会随着你的穿着习惯形成独一无二的色落纹路。这篇指南带你了解赤耳丹宁的一切——从面料到品牌，从脱浆到养护。',
    contentHtml: `<p>养牛，是型男穿搭领域最有趣的话题之一。一条原色赤耳牛仔裤，在穿着6个月到1年后，会呈现出只属于你的独特色落——膝盖处的猫须、大腿处的蜂窝纹、口袋处的手机印，每一处都是时间的印记。</p>
<h2>什么是赤耳丹宁？</h2>
<p>赤耳（Selvedge）指的是使用老式有梭织机织造的丹宁布边缘特有的红色织边。这种织法密度更高、纹理更丰富，是高品质牛仔裤的标志。</p>
<h2>品牌推荐</h2>
<p>从日本冈山的桃太郎（Momotaro）、武士（Samurai），到美国老牌李维斯复古线（LVC），再到性价比极高的国产Unbranded Brand，我们为你梳理了不同预算下的最佳选择。</p>
<h2>脱浆与初次穿着</h2>
<p>新买的原牛通常带有浆料，需要先进行脱浆处理。温水浸泡、自然晾干，然后就可以开始你的养牛之旅了。前6个月尽量少洗，让折痕充分定型。</p>`,
    categorySlug: 'mens-style',
    categoryName: '型男穿搭',
    author: '丹宁老张',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20stylish%20Chinese%20man%20in%20his%2030s%20with%20undercut%20hairstyle%2C%20wearing%20denim%20jacket%2C%20artistic%20expression%2C%20studio%20portrait%20lighting%2C%20dark%20background&width=100&height=100&seq=avatar-danning&orientation=squarish',
    publishDate: '2024-11-28',
    readTime: 10,
    image: 'https://readdy.ai/api/search-image?query=Closeup%20detail%20photography%20of%20raw%20selvedge%20denim%20jeans%20texture%20with%20visible%20red%20selvedge%20line%20and%20natural%20wear%20fading%20patterns%2C%20dark%20indigo%20fabric%20with%20subtle%20whiskering%2C%20artisan%20craftsmanship%20aesthetic%2C%20warm%20natural%20window%20lighting%2C%20textile%20macro%20photography&width=1200&height=675&seq=article-denim-002&orientation=landscape',
    tags: ['牛仔裤', '丹宁', '赤耳', '养牛', '穿搭'],
    featured: true,
  },
  {
    id: 'art-003',
    slug: 'mechanical-keyboard-reviews',
    title: '五大旗舰机械键盘横评：哪一把值得你掏腰包？',
    excerpt: '我们实测了五款2000元价位的旗舰机械键盘，从轴体手感到做工细节，从RGB灯效到无线延迟，全方位对比评测。',
    contentHtml: `<p>机械键盘市场在2024年迎来了前所未有的繁荣。从传统Cherry轴到国产自研轴体，从有线到三模无线，选择太多反而让人更难决策。</p>
<p>本次横评我们选取了五款最具代表性的旗舰产品：HHKB Professional Hybrid Type-S、Leopold FC980M、Keychron Q1 Pro、Wooting 60HE+以及Matrix Abel X。</p>
<h2>轴体对比</h2>
<p>不同轴体带来的打字体验天差地别。线性轴适合游戏，段落轴适合打字，而静电容轴则是另一种维度的享受。我们将每种轴体的触发力度、行程、声音进行了详细量化对比。</p>
<h2>做工与材质</h2>
<p>外壳材质（塑料 vs 铝合金）、键帽材质（ABS vs PBT）、PCB板厚度——这些影响手感和声音的细节，往往在参数表上找不到。</p>`,
    categorySlug: 'digital-geek',
    categoryName: '数码极客',
    author: '键盘侠阿凯',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20tech%20enthusiast%20man%20with%20glasses%2C%20wearing%20black%20t-shirt%2C%20friendly%20smile%2C%20studio%20portrait%20with%20soft%20lighting%2C%20clean%20dark%20background&width=100&height=100&seq=avatar-keyboard&orientation=squarish',
    publishDate: '2024-12-08',
    readTime: 15,
    image: 'https://readdy.ai/api/search-image?query=Five%20premium%20mechanical%20keyboards%20arranged%20in%20a%20row%20on%20dark%20wooden%20desk%2C%20various%20colorways%20and%20form%20factors%2C%20warm%20desk%20lamp%20lighting%20from%20above%2C%20visible%20custom%20keycaps%20and%20artisan%20details%2C%20tech%20product%20photography%2C%20clean%20aesthetic&width=1200&height=675&seq=article-keyboard-003&orientation=landscape',
    tags: ['机械键盘', '数码评测', '外设', '键盘推荐'],
    featured: true,
  },
  {
    id: 'art-004',
    slug: 'camping-gear-essentials',
    title: '新手露营装备清单：花最少的钱，搭最舒服的营地',
    excerpt: '想入坑露营但不知从何下手？这份经过实战检验的装备清单，从帐篷到炉具，帮你避开智商税，只买真正需要的东西。',
    contentHtml: `<p>露营的门槛其实并不高。你不必一开始就投入数万元购买全套顶级装备——很多入门级产品的体验已经相当不错。关键是要搞清楚：什么是必需品，什么是可有可无的加分项。</p>
<h2>睡眠系统：舒适露营的基石</h2>
<p>帐篷、睡袋、防潮垫——这三样东西决定了你在野外能不能睡个好觉。我们推荐先从三季帐入手，搭配舒适温标合适的羽绒睡袋和充气垫。</p>
<h2>厨房系统：野外美食家的装备</h2>
<p>一套轻便的炉头、一口耐用的铸铁锅、一把好用的折叠刀，就能让你在野外做出不输家里的美味。我们特别推荐了几款性价比极高的国产品牌。</p>
<h2>照明与工具</h2>
<p>头灯、营地灯、多功能工具——这些小件装备往往在关键时刻发挥大作用。</p>`,
    categorySlug: 'outdoor-adventure',
    categoryName: '户外探险',
    author: '野人阿飞',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20outdoorsy%20Chinese%20man%20in%20his%2030s%20with%20tanned%20skin%2C%20wearing%20outdoor%20vest%2C%20confident%20adventurous%20expression%2C%20natural%20outdoor%20lighting%2C%20mountain%20background&width=100&height=100&seq=avatar-outdoor&orientation=squarish',
    publishDate: '2024-11-20',
    readTime: 9,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20campsite%20scene%20at%20sunset%20with%20canvas%20bell%20tent%20and%20campfire%2C%20camping%20gear%20neatly%20arranged%20on%20wooden%20picnic%20table%2C%20warm%20golden%20sunlight%20through%20pine%20trees%2C%20mountain%20lake%20in%20background%2C%20adventure%20lifestyle%20photography&width=1200&height=675&seq=article-camping-004&orientation=landscape',
    tags: ['露营', '户外装备', '新手指南', '帐篷'],
    featured: false,
  },
  {
    id: 'art-005',
    slug: 'craft-beer-beginners',
    title: '精酿啤酒入门：从工业拉格到IPA的味觉进化之路',
    excerpt: '喝腻了工业啤酒？精酿的世界比你想象的更精彩。从啤酒分类到品鉴技巧，这篇指南帮你打开精酿的大门。',
    contentHtml: `<p>精酿啤酒不是玄学，它只是比工业啤酒多了一些诚意和想象力。水、麦芽、啤酒花、酵母——四种原料的无限组合，造就了从清爽的皮尔森到浓郁帝国世涛的广阔风味光谱。</p>
<h2>啤酒风格速览</h2>
<p>IPA（印度淡色艾尔）、Stout（世涛）、Saison（赛松）、Sour（酸啤）——了解这些基本风格，你就能在酒吧里自信地点酒了。</p>
<h2>如何品鉴一杯精酿</h2>
<p>看颜色、闻香气、品味道、感受回味——精酿品鉴自有门道。我们还会推荐几款适合新手的入门酒款，帮你在不踩雷的前提下快速建立味觉参考系。</p>`,
    categorySlug: 'quality-life',
    categoryName: '品质生活',
    author: '酒鬼老王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20bearded%20Chinese%20man%20in%20his%2040s%2C%20wearing%20casual%20linen%20shirt%2C%20warm%20friendly%20expression%2C%20studio%20portrait%20with%20dramatic%20side%20lighting%2C%20dark%20background&width=100&height=100&seq=avatar-beer&orientation=squarish',
    publishDate: '2024-12-01',
    readTime: 8,
    image: 'https://readdy.ai/api/search-image?query=Craft%20beer%20flight%20tasting%20photography%20with%20four%20different%20beer%20styles%20in%20elegant%20glasses%20on%20dark%20wooden%20bar%20counter%2C%20amber%20and%20dark%20beer%20colors%2C%20warm%20pub%20ambient%20lighting%2C%20shallow%20depth%20of%20field%2C%20masculine%20sophisticated%20aesthetic&width=1200&height=675&seq=article-beer-005&orientation=landscape',
    tags: ['精酿啤酒', '品酒', '生活方式', '入门指南'],
    featured: false,
  },
  {
    id: 'art-006',
    slug: 'first-mechanical-watch',
    title: '人生第一块机械表：万元以内最值得入手的8款腕表',
    excerpt: '机械表是男人为数不多的配饰之一。万元预算内，从潜水表到正装表，我们帮你筛选了8款兼具品质与性价比的选择。',
    contentHtml: `<p>有人说，男人看表。虽然这句话有些绝对，但一块得体的机械腕表，确实能让整个人的气场提升一个档次。对于初次接触机械表的朋友，万元是一个很好的起点——既有足够的品质保障，又不会过于沉重。</p>
<h2>潜水表：粗犷实用派</h2>
<p>精工Prospex系列、美度领航者、汉米尔顿卡其海军——这些潜水表不仅防水性能出色，设计上也足够硬朗阳刚，适合日常通勤和周末户外。</p>
<h2>正装表：优雅绅士之选</h2>
<p>天梭力洛克、美度贝伦赛丽——简洁大气的表盘设计，搭配皮带或钢带，在商务场合从容得体。</p>
<h2>军表风格：复古硬汉风</h2>
<p>汉米尔顿卡其野战——二战军表风格复刻，粗犷中带着历史感，是很多男人的心头好。</p>`,
    categorySlug: 'watch-appreciation',
    categoryName: '腕表鉴赏',
    author: '表叔',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20elegant%20Chinese%20man%20in%20his%2040s%2C%20wearing%20suit%20and%20tie%2C%20sophisticated%20expression%2C%20studio%20portrait%20with%20classic%20lighting%2C%20dark%20luxurious%20background&width=100&height=100&seq=avatar-watch&orientation=squarish',
    publishDate: '2024-12-10',
    readTime: 11,
    image: 'https://readdy.ai/api/search-image?query=Eight%20entry%20level%20luxury%20mechanical%20watches%20displayed%20elegantly%20on%20dark%20leather%20watch%20roll%2C%20various%20brands%20and%20styles%20including%20diver%20and%20dress%20watches%2C%20warm%20directional%20studio%20lighting%2C%20product%20photography%2C%20premium%20masculine%20aesthetic&width=1200&height=675&seq=article-watch-006&orientation=landscape',
    tags: ['机械表', '腕表推荐', '万元表', '入门'],
    featured: true,
  },
  {
    id: 'art-007',
    slug: 'leather-boot-care',
    title: '皮靴养护完全手册：让你的战靴穿十年',
    excerpt: '一双好皮靴可以陪你走很远的路——前提是你懂得如何养护它。从清洁到上油，从换底到收纳，完整皮靴养护指南。',
    contentHtml: `<p>好皮靴是会说话的。穿了三个月没擦过的靴子，和定期养护的靴子，摆在面前一眼就能看出区别。皮靴养护并不复杂，关键是频率和方法。</p>
<h2>日常清洁</h2>
<p>每次穿完后用马毛刷刷去灰尘，这是最简单也最重要的步骤。如果有泥污，用微湿的布擦拭后自然晾干，切忌暴晒或用热风烘干。</p>
<h2>深层滋养</h2>
<p>根据皮革类型选择合适的护理产品——油皮用貂油，植鞣革用牛脚油，翻毛皮用专用喷雾。上油前确保鞋面干净干燥，少量多次，用棉布打圈涂抹均匀。</p>
<h2>换底与维修</h2>
<p>一双好靴子的鞋底是消耗品。当大底磨损到一定程度时，找靠谱的修鞋师傅更换鞋底，可以让靴子焕然一新。固特异工艺的靴子特别适合反复换底。</p>`,
    categorySlug: 'mens-style',
    categoryName: '型男穿搭',
    author: '丹宁老张',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20stylish%20Chinese%20man%20in%20his%2030s%20with%20undercut%20hairstyle%2C%20wearing%20denim%20jacket%2C%20artistic%20expression%2C%20studio%20portrait%20lighting%2C%20dark%20background&width=100&height=100&seq=avatar-danning&orientation=squarish',
    publishDate: '2024-11-15',
    readTime: 7,
    image: 'https://readdy.ai/api/search-image?query=Vintage%20leather%20work%20boots%20with%20beautiful%20patina%20and%20wear%20being%20polished%20with%20horsehair%20brush%2C%20leather%20care%20products%20neatly%20arranged%20nearby%20on%20dark%20wood%20surface%2C%20warm%20workshop%20lighting%2C%20craftsmanship%20photography&width=1200&height=675&seq=article-boots-007&orientation=landscape',
    tags: ['皮靴', '养护', '固特异', '穿搭'],
    featured: false,
  },
  {
    id: 'art-008',
    slug: 'titanium-edc-flashlight',
    title: '钛合金EDC手电选购指南：小而强大的光明利器',
    excerpt: 'EDC手电是男人口袋里的微型探照灯。钛合金材质兼具轻量、强度与质感，这篇指南帮你从数十款产品中找到最适合的那一支。',
    contentHtml: `<p>钛合金在EDC领域的地位无可撼动——它比钢轻40%，强度却不输，而且会随着使用形成独特的氧化层，呈现出迷人的蓝紫色光泽。用在手电上，钛合金更是将质感拉满。</p>
<h2>选择EDC手电的关键参数</h2>
<p>流明数（亮度）、坎德拉值（射程）、色温、续航时间、充电方式——我们逐一解析这些参数在实际使用中的意义。</p>
<h2>热门型号对比</h2>
<p>从ReyLight的Pineapple Mini到Olight的Baton系列，从RovyVon的钥匙扣灯到ReyLight LANapple，我们对比了10款热门钛合金EDC手电的优缺点。</p>`,
    categorySlug: 'hardcore-gear',
    categoryName: '硬核装备',
    author: '老炮',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20mature%20Chinese%20man%20in%20his%2040s%20with%20short%20hair%20and%20beard%2C%20wearing%20dark%20flannel%20shirt%2C%20confident%20expression%2C%20warm%20studio%20lighting%2C%20dark%20background&width=100&height=100&seq=avatar-laopao&orientation=squarish',
    publishDate: '2024-10-22',
    readTime: 9,
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20titanium%20EDC%20flashlights%20of%20various%20sizes%20lined%20up%20on%20dark%20slate%20surface%2C%20visible%20machining%20details%20and%20titanium%20texture%2C%20one%20flashlight%20turned%20on%20casting%20warm%20beam%2C%20product%20photography%20with%20dramatic%20side%20lighting&width=1200&height=675&seq=article-flashlight-008&orientation=landscape',
    tags: ['EDC', '手电', '钛合金', '装备评测'],
    featured: false,
  },
  {
    id: 'art-009',
    slug: 'home-gym-setup',
    title: '家庭健身房搭建指南：小空间也能练出硬汉身材',
    excerpt: '不想去健身房排队等器械？在家打造一个迷你但高效的健身空间，只需几件核心装备，随时随地练起来。',
    contentHtml: `<p>家庭健身房的优势很明显：不用通勤、不用排队、随时开练。但空间有限的情况下，如何选择最有效的器械就成了关键问题。</p>
<h2>核心装备清单</h2>
<p>一副可调节哑铃、一根引体向上杆、一条弹力带、一张瑜伽垫——这四样装备几乎可以覆盖全身所有肌群的训练。如果再有一台划船机或风阻单车，有氧训练也搞定了。</p>
<h2>空间规划</h2>
<p>哪怕只有4平方米的阳台一角，合理规划也能成为一个高效的训练区。我们提供了几种不同空间的布局建议。</p>`,
    categorySlug: 'quality-life',
    categoryName: '品质生活',
    author: '铁人阿Ken',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20fit%20muscular%20Chinese%20man%20in%20his%2030s%2C%20wearing%20black%20athletic%20tank%20top%2C%20determined%20expression%2C%20gym%20lighting%2C%20dark%20background&width=100&height=100&seq=avatar-fitness&orientation=squarish',
    publishDate: '2024-10-18',
    readTime: 8,
    image: 'https://readdy.ai/api/search-image?query=Compact%20home%20gym%20setup%20in%20a%20small%20room%20with%20adjustable%20dumbbells%20pull%20up%20bar%20resistance%20bands%20and%20yoga%20mat%20on%20dark%20rubber%20flooring%2C%20industrial%20minimalist%20aesthetic%2C%20warm%20natural%20light%20from%20window%2C%20clean%20organized%20setup&width=1200&height=675&seq=article-gym-009&orientation=landscape',
    tags: ['健身', '家庭健身房', '哑铃', '训练'],
    featured: false,
  },
  {
    id: 'art-010',
    slug: 'noise-cancelling-headphones',
    title: '降噪耳机选购全攻略：从通勤到飞行，哪款最适合你？',
    excerpt: '降噪耳机已经成为差旅和通勤的刚需。我们实测了6款主流降噪耳机，从降噪深度到音质表现，帮你做出最明智的选择。',
    contentHtml: `<p>一副好的降噪耳机，可以在地铁上、飞机上、咖啡厅里为你创造出一片宁静的空间。但降噪技术、音质调校、佩戴舒适度、续航能力这些维度，不同产品的表现差异很大。</p>
<h2>主动降噪技术解析</h2>
<p>前馈式、反馈式、混合式——不同的降噪方案各有优劣。2024年的旗舰产品普遍采用自适应混合降噪，能根据环境噪音自动调整降噪强度。</p>
<h2>六款热门产品横评</h2>
<p>Sony WH-1000XM5、Bose QC Ultra、Apple AirPods Max、B&W Px8、森海塞尔Momentum 4、索尼WF-1000XM5——从全尺寸到头戴再到真无线，全方位对比。</p>`,
    categorySlug: 'digital-geek',
    categoryName: '数码极客',
    author: '键盘侠阿凯',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20tech%20enthusiast%20man%20with%20glasses%2C%20wearing%20black%20t-shirt%2C%20friendly%20smile%2C%20studio%20portrait%20with%20soft%20lighting%2C%20clean%20dark%20background&width=100&height=100&seq=avatar-keyboard&orientation=squarish',
    publishDate: '2024-10-05',
    readTime: 13,
    image: 'https://readdy.ai/api/search-image?query=Six%20premium%20noise%20cancelling%20headphones%20from%20different%20brands%20displayed%20on%20dark%20wooden%20shelf%2C%20including%20over-ear%20and%20in-ear%20models%2C%20elegant%20product%20photography%20with%20soft%20studio%20lighting%2C%20dark%20masculine%20background&width=1200&height=675&seq=article-headphones-010&orientation=landscape',
    tags: ['降噪耳机', '数码评测', '索尼', 'Bose', '通勤'],
    featured: false,
  },
];

export const getArticleBySlug = (slug: string) => articles.find((a) => a.slug === slug);

export const getArticlesByCategory = (categorySlug: string) =>
  articles.filter((a) => a.categorySlug === categorySlug);

export const getFeaturedArticles = () => articles.filter((a) => a.featured);

export const getRelatedArticles = (currentSlug: string, categorySlug: string, limit: number = 3) =>
  articles.filter((a) => a.categorySlug === categorySlug && a.slug !== currentSlug).slice(0, limit);